import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren & ComponentStyling;

export const Divider = ({ children, className, style }: P) => {
  if (children) {
    return (
      <div className={cn('flex items-center', className)} style={style}>
        <div className="h-px flex-1 bg-tiga-border-lighter" />
        <span className="px-2 text-sm text-tiga-text-lighter">{children}</span>
        <div className="h-px flex-1 bg-tiga-border-lighter" />
      </div>
    );
  }

  return (
    <hr
      className={cn('h-px border-0 bg-tiga-border-default', className)}
      style={style}
    />
  );
};
